import { NavigationGuard } from "vue-router";
import userStore from "@/store/userStore";

const ensureImageNotMaximized: NavigationGuard = (_to, _from, next) => {
  if (userStore.isImageMaximized === true) {
    userStore.isImageMaximized = false;
    next(false);
    return;
  }
  next();
};

export default ensureImageNotMaximized;
